import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { SubscriptionStatus } from '../../../../services/paymentService';
import { TIER_LABELS } from '../../types';

interface DowngradeConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  subscriptionStatus: SubscriptionStatus | null;
  activeTier: string;
  downgradeLoading: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DowngradeConfirmModal({
  open,
  onOpenChange,
  subscriptionStatus,
  activeTier,
  downgradeLoading,
  onConfirm,
  onCancel,
}: DowngradeConfirmModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <DialogTitle className="text-2xl">Confirm Downgrade</DialogTitle>
          <DialogDescription className="text-center mt-2">
            This action will open a new PayPal dialog that will ask for your approval to switch to Starter starting from your next billing cycle.
          </DialogDescription>
        </DialogHeader>
        {subscriptionStatus && (
          <div className="space-y-3 mt-4">
            <p className="text-sm text-center text-muted-foreground">
              Upon your approval, you will remain <strong className="text-foreground">{TIER_LABELS[activeTier] || activeTier}</strong> until your current billing cycle ends.
            </p>
            {subscriptionStatus.subscription_end_date && (
              <p className="text-sm text-center font-medium">
                Your current billing cycle ends on:{' '}
                <strong className="text-primary">
                  {new Date(subscriptionStatus.subscription_end_date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </strong>
              </p>
            )}
          </div>
        )}
        <DialogFooter className="flex-col sm:flex-row gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={onCancel}
            className="w-full sm:w-auto"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={downgradeLoading !== null}
            className="w-full sm:w-auto"
          >
            {downgradeLoading ? 'Processing...' : 'Continue to PayPal'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

